import React,{useEffect,useId,useRef,useState} from 'react';
import {FiChevronDown,FiCloud,FiFolder,FiHardDrive,FiPlus} from 'react-icons/fi';
import './MediaAddMenu.css';

/**
 * One entry for all interview sources. The native file input, cloud importer
 * and reusable media picker retain their existing implementations.
 */
export default function MediaAddMenu({
 disabled=false,signedIn=false,hasProject=false,
 onComputer,onCloud,onLibrary
}){
 const [open,setOpen]=useState(false);
 const root=useRef(null);
 const trigger=useRef(null);
 const menu=useRef(null);
 const id=useId();
 const items=[
  {key:'computer',label:'From computer',description:'Choose video files',
   icon:FiHardDrive,disabled:false,action:onComputer},
  {key:'cloud',label:'From cloud',description:'Drive, Dropbox or Frame.io',
   icon:FiCloud,disabled:!signedIn,reason:'Sign in to import cloud files',action:onCloud},
  {key:'library',label:'From Media Library',description:'Reuse an existing interview',
   icon:FiFolder,disabled:!signedIn||!hasProject,
   reason:!signedIn?'Sign in to access Media Library':'Save your first interview before using the library',
   action:onLibrary}
 ];
 useEffect(()=>{
  if(!open)return undefined;
  const dismiss=event=>{
   if(!root.current?.contains(event.target))setOpen(false);
  };
  const escape=event=>{
   if(event.key!=='Escape')return;
   event.stopPropagation();setOpen(false);trigger.current?.focus();
  };
  document.addEventListener('pointerdown',dismiss,true);
  document.addEventListener('keydown',escape);
  requestAnimationFrame(()=>menu.current?.querySelector('[role="menuitem"]:not(:disabled)')?.focus());
  return()=>{
   document.removeEventListener('pointerdown',dismiss,true);
   document.removeEventListener('keydown',escape);
  };
 },[open]);
 useEffect(()=>{if(disabled)setOpen(false);},[disabled]);
 const choose=option=>{
  if(disabled||option.disabled)return;
  setOpen(false);
  option.action?.();
 };
 const onMenuKeyDown=event=>{
  if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
  event.preventDefault();
  const enabled=[...(menu.current?.querySelectorAll('[role="menuitem"]:not(:disabled)')||[])];
  if(!enabled.length)return;
  const current=enabled.indexOf(document.activeElement);
  const next=event.key==='Home'?0:event.key==='End'?enabled.length-1:
   event.key==='ArrowDown'?(current+1)%enabled.length:
   (current<0?enabled.length:current+enabled.length-1)%enabled.length;
  enabled[next]?.focus();
 };
 return <div className="media-add-menu" ref={root}>
  <button ref={trigger} type="button" className="media-add-trigger"
   disabled={disabled} aria-haspopup="menu" aria-controls={id} aria-expanded={open}
   onClick={()=>setOpen(value=>!value)}>
   <FiPlus aria-hidden="true"/><span>Add media</span>
   <FiChevronDown className={open?'is-open':''} aria-hidden="true"/>
  </button>
  {open&&<div ref={menu} className="media-add-popover" id={id} role="menu"
   aria-label="Choose where to add interviews" onKeyDown={onMenuKeyDown}>
   {items.map(option=>{
    const Icon=option.icon;
    return <button type="button" role="menuitem" key={option.key}
     className="media-add-option" disabled={option.disabled}
     title={option.disabled?option.reason:option.label}
     onClick={()=>choose(option)}>
     <span className="media-add-option-icon"><Icon aria-hidden="true"/></span>
     <span className="media-add-option-copy">
      <strong>{option.label}</strong><small>{option.description}</small>
     </span>
    </button>;
   })}
  </div>}
 </div>;
}
